import React from 'react';

const STATUS_META = {
    CONNECTED: { label: 'Connected', className: 'gateway-card__status--connected' },
    LOST: { label: 'Lost', className: 'gateway-card__status--lost' },
};

const formatDateTime = value => {
    if (!value) {
        return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '—';
    }
    return date.toLocaleString();
};

const formatValue = (value, unit = '') => {
    if (value === null || value === undefined || value === '') {
        return '—';
    }
    return unit ? `${value} ${unit}` : value;
};

const GatewayField = ({ label, value }) => (
    <div className="gateway-card__field">
        <span className="gateway-card__field-label">{label}</span>
        <span className="gateway-card__field-value">{value}</span>
    </div>
);

const GatewayCard = ({ gateway }) => {
    const status = (gateway.health?.status || '').toUpperCase();
    const statusMeta = STATUS_META[status] || { label: 'Unknown', className: 'gateway-card__status--unknown' };
    const gatewayInfo = gateway.info ?? {};
    const parameters = gatewayInfo.parameters ?? {};

    return (
        <div className="gateway-card">
            <div className="gateway-card__head">
                <div className="gateway-card__title">
                    <span className="gateway-card__name">{gateway.custom_device_name || gateway.name || 'Gateway'}</span>
                    <span className="gateway-card__device-id">{gateway.id}</span>
                </div>
                <span className={`gateway-card__status ${statusMeta.className}`}>
                    <span className="gateway-card__status-dot" />
                    {statusMeta.label}
                </span>
            </div>

            <div className="gateway-card__section-label">Connection</div>
            <div className="gateway-card__grid">
                <GatewayField label="Status" value={statusMeta.label} />
                <GatewayField label="Gateway firmware" value={formatValue(gateway.health?.version)} />
                <GatewayField label="Last seen" value={formatDateTime(gateway.health?.last_heartbeat)} />
            </div>

            <div className="gateway-card__section-label">Hardware</div>
            <div className="gateway-card__grid">
                <GatewayField label="Serial number" value={formatValue(gatewayInfo.reference)} />
                <GatewayField label="Inverter manufacturer" value={formatValue(gatewayInfo.inverter_manufacturer)} />
                <GatewayField label="Inverter model" value={formatValue(gatewayInfo.inverter_model)} />
                <GatewayField label="Inverter serial" value={formatValue(gatewayInfo.inverter_serial_number)} />
                <GatewayField label="Inverter firmware" value={formatValue(gatewayInfo.inverter_firmware_version)} />
                <GatewayField label="Gateway hardware" value={formatValue(gatewayInfo.gateway_hardware_version)} />
            </div>

            <div className="gateway-card__section-label">Capacity</div>
            <div className="gateway-card__grid">
                <GatewayField
                    label="Battery capacity"
                    value={
                        <>
                            {formatValue(parameters.energy_capacity, 'kWh')}
                            {/* Distinguishes an operator-supplied figure from the inverter's own, and
                                flags when the two disagree — the override still governs either way. */}
                            {parameters.energy_capacity_source === 'override' && (
                                <span style={{ marginLeft: 6, fontSize: 12, color: '#6b7280' }}>(manually set)</span>
                            )}
                            {parameters.energy_capacity_diverges && (
                                <span style={{ marginLeft: 6, fontSize: 12, color: '#b45309' }}>differs from inverter</span>
                            )}
                        </>
                    }
                />
                <GatewayField label="Inverter rated power" value={formatValue(parameters.inverter_rated_power, 'kW')} />
                <GatewayField label="Battery max power" value={formatValue(parameters.battery_max_power, 'kW')} />
            </div>
        </div>
    );
};

export default GatewayCard;
